type AnalyticsPayload = Record<string, unknown>;

export const trackAnalyticsEvent = (eventName: string, payload: AnalyticsPayload = {}) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.info(`[analytics] ${eventName}`, payload);
  }
};
